import { z } from 'zod';

const WebEnvSchema = z.object({
  /** Vacio = mismo origen (servidor que aloja la web o proxy de Vite en desarrollo). */
  VITE_API_BASE_URL: z
    .string()
    .trim()
    .default('')
    .refine((value) => value === '' || URL.canParse(value), 'Debe ser una URL absoluta o vacio'),
  MODE: z.string(),
});

export interface WebConfig {
  readonly apiBaseUrl: string;
  readonly mode: string;
}

/**
 * Valida las variables `VITE_*` expuestas por Vite. Una configuracion invalida
 * detiene el arranque con un mensaje explicito en lugar de fallar mas tarde.
 */
export function parseWebConfig(env: Record<string, unknown>): WebConfig {
  const parsed = WebEnvSchema.safeParse(env);
  if (!parsed.success) {
    const details = parsed.error.issues
      .map((issue) => `${issue.path.join('.')}: ${issue.message}`)
      .join('; ');
    throw new Error(`Configuracion web invalida: ${details}`);
  }
  return {
    apiBaseUrl: parsed.data.VITE_API_BASE_URL.replace(/\/+$/, ''),
    mode: parsed.data.MODE,
  };
}
